module.exports = __webpack_public_path__ + "1e00d7bb412e07357643f79b612ec456.png";